import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const Dashboard = lazy(() => import('../../pages/Dashboard/Recruiter/index'));
const Feed = lazy(() => import('../../pages/Feed'));
const Candidates = lazy(() => import('../../pages/Candidates/Candidates'));
const Companies = lazy(() => import('../../pages/Companies'));
const Jobs = lazy(() => import('../../pages/Jobs'));
const Projects = lazy(() => import('../../pages/Projects'));
const IndividualProject = lazy(() => import('../../pages/Projects/IndividualProject'));
const Leaves = lazy(() => import('../../pages/HrPayroll/Leaves'));
const NotFound = lazy(() => import('../../NotFound'));
const OvertimeSubmission = lazy(() => import('../../pages/HrPayroll/OvertimeSubmission'));
const WFHRequests = lazy(() => import('../../pages/HrPayroll/WFHRequests'));
const WorkflowManagement = lazy(() => import('../../pages/WorkFlow/WorkFlow'));
const TeamsMeetings = lazy(() => import('../../pages/Meetings/TeamMeetings'));
const PipelineManagement = lazy(() => import('../../pages/Candidates/PipelineManagement'));
const Onboarding = lazy(() => import('../../pages/Onboarding/Onboarding'));
const OnboardingTemplates = lazy(() => import('../../pages/Onboarding/OnboardingTemplates'));
const OfferTemplates = lazy(() => import('../../pages/OfferTemplates/OfferTemplates'));
const Offboarding = lazy(() => import('../../pages/Offboarding/Offboarding'));
const OffboardingTemplates = lazy(() => import('../../pages/Offboarding/OffboardingTemplates'));

const recruiterRoutesConfig = [
  { path: '/v1/recruiter/dashboard', component: Dashboard },
  { path: '/v1/candidates', component: Candidates },
  { path: '/v1/candidates/user/:user_id', component: Candidates },
  { path: '/v1/candidates/status/:status', component: Candidates },
  { path: '/v1/companies', component: Companies },
  { path: '/v1/jobs', component: Jobs },
  { path: '/v1/projects', component: Projects },
  { path: '/v1/projects/:project_id', component: IndividualProject },

  { path: '/v1/managed-hr/leave-requests', component: Leaves },
  { path: '/v1/managed-hr/overtime-requests', component: OvertimeSubmission },
  { path: '/v1/managed-hr/wfh', component: WFHRequests },
  { path: '/v1/workflow', component: WorkflowManagement },
  { path: '/v1/teams-meetings', component: TeamsMeetings },
  { path: '/v1/pipeline-management', component: PipelineManagement },
  // interview-calendar redirects to unified meetings page
  { path: '/v1/interview-calendar', component: () => React.createElement(Navigate, { to: '/v1/teams-meetings', replace: true }) },

  // Onboarding (moved from HR)
  { path: '/v1/recruiter/onboarding', component: Onboarding },
  { path: '/v1/recruiter/onboarding-templates', component: OnboardingTemplates },

  // Offer letter templates (moved from HR)
  { path: '/v1/recruiter/offer-templates', component: OfferTemplates },

  // Offboarding (moved from HR)
  { path: '/v1/recruiter/offboarding', component: Offboarding },
  { path: '/v1/recruiter/offboarding-templates', component: OffboardingTemplates },

  { path: '/v1/recruiter/*', component: NotFound },
];

export default recruiterRoutesConfig;
